import { JobOrder, JobOrderOptions } from 'data/models/JobOrder';
import { ReqChangeId, makePITKey, makePITDataKey } from './PITUtils';

export type JobOrderPITOptions = ReqChangeId<JobOrderOptions>;
export const JobOrderPITKey = makePITKey<JobOrder>(JobOrder.key);
export const JobOrderPITDataKey = makePITDataKey<JobOrderOptions>(JobOrder.dataKey);



// WEBPACK FOOTER //
// ./data/models/JobOrderPIT.ts